<template>
  <StepLayout
    :back="back"
    :save="save"
    :next="next"
    :isEditRoute="true"
    help-link="https://signable.help/sharing-envelopes-templates/"
    buttonDataEc="envelopes_sharing_page"
  >
    <template v-slot:title>
      {{ $t('ui.envelopes.create.steps.sharing.title', { title }) }}
    </template>

    <Sharing
      v-model="sharing"
      @itemAdded="itemAdded"
      @itemRemoved="itemRemoved"
      @permissionChanged="permissionChanged"
      :permittedActorsListTitle="
        $t('sharing.currentSharing', { resource: $t('functional.envelope') })
      "
    />
  </StepLayout>
</template>

<script setup>
// @ts-check
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router/composables';

import { logAmplitudeEvent } from '@/utils/analytics';
import {
  useEnvelope,
  useEnvelopesStepsNavigation,
} from '@/composables/envelopes';

import StepLayout from '@/components/layouts/StepLayout';
import Sharing from '@/components/Sharing.vue';

const route = useRoute();

const { envelope } = useEnvelope(route.params.fingerprint);

const title = computed(() => envelope.value.title);

// initialise local state
const sharing = ref({
  ...envelope.value.sharing,
  everyone_permission: envelope.value.everyone_permission,
});

const updateValue = computed(() => sharing.value);

// action param is temporary, will be replaced when tanstack query is implemented
const { back, save, next } = useEnvelopesStepsNavigation(
  'envelopes/updateEnvelopes',
  updateValue,
);

function itemAdded(item) {
  logAmplitudeEvent('envelopes_sharing_page--added_actor_to_template_sharing', {
    type: item.type,
  });
}
function itemRemoved(item) {
  logAmplitudeEvent(
    'envelopes_sharing_page--removed_actor_from_template_sharing',
    { type: item.type },
  );
}
function permissionChanged(value) {
  logAmplitudeEvent('envelopes_sharing_page--permission_changed', {
    type: value.slug,
  });
}
</script>
